import {proxy} from 'valtio';

export interface State {
    intro: boolean;
    color: string;
    isLogoTexture: boolean;
    isFullTexture: boolean;
    logoDecal: string;
    fullDecal: string;
    imageBase64?: string;
    format?: string;
    quality?: string;
    caption?: string;
    tags?: string[];
    lockCustomDimension?: boolean;
}

const state = proxy<State>({
    intro: true,
    color: '#353934',
    isLogoTexture: true,
    isFullTexture: false,
    logoDecal: './tshirt-assets/alpha.png',
    fullDecal: './tshirt-assets/alpha.png',
    imageBase64: '',
    format: '',
    quality: '',
    caption: '',
    tags: [],
    lockCustomDimension: false,
});

export const defaultState = state;

export default state;
